import React, { useEffect} from "react";
import PromotionCouponsTable from "../../../../components/Widgets/Tables/PromotionCouponsTable";
import GetRequest from "../../../../service/GetRequest";

const PromotionsPage = ({setActivePath}) => {
    

    useEffect(() => {
        setActivePath("Promotions");
      }, [setActivePath]);
  return (
    <div className="outlet-container">
        <PromotionCouponsTable/>
    </div>
  )
}

export default PromotionsPage
